import { dateFormat } from 'common/helpers';
import { Flex } from 'components';
import './style.scss';

function DateBlock(props: { date?: string | null; isRightAlign: boolean }) {
  return (
    <Flex
      direction='column'
      alignItems={props.isRightAlign ? 'flex-end' : undefined}
    >
      <DateTime
        date={props.date}
        isRightAlign={props.isRightAlign}
      />
    </Flex>
  );
}

function DateTime(props: { date?: string | null; isRightAlign: boolean }) {
  if (props.date == null) {
    return <div className='trip-date-LnAHy'>N/A</div>;
  }

  const time = dateFormat(props.date, 'HH:mm');
  const date = dateFormat(props.date, 'DD MMMM');

  return (
    <div>
      <Flex
        gap={5}
        className='trip-date-LnAHy'
        justifyContent={props.isRightAlign ? 'flex-end' : undefined}
      >
        {date.datetime}
      </Flex>
      <Flex
        gap={5}
        className='date-block-time-Maba'
        justifyContent={props.isRightAlign ? 'flex-end' : undefined}
      >
        {time.datetime}
      </Flex>
    </div>
  );
}

export default DateBlock;
